import KendoTreeView from '../KendoTreeView'
import KendoTreeViewItem from '../KendoTreeView/KendoTreeViewItem'

let KendoTreeViewInstaller = class {
    static install(Vue) {
        Vue.component(KendoTreeView.name, KendoTreeView)
        Vue.component(KendoTreeViewItem.name, KendoTreeViewItem)
    }
}

export default KendoTreeViewInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoTreeViewInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/kendo-treeview-installer/index.js